module.exports = __webpack_public_path__ + "static/media/doc.e8fd30b4.png";